import React, { Component } from "react";
import { Switch, Route, BrowserRouter, Redirect } from "react-router-dom";
import PrimaryDashboard from "./screen/primary-dashboard/PrimaryDashborad";
import SecondaryDashboard from "./screen/secondary-dashboard/SecondaryDashboard";
import Layout from "./components/Layout/Layout";
import LoginScreen from "./screen/login-screen/LoginScreen";
import { connect } from "react-redux";
import AuthMiddleware from "./store/middleware/authMiddleware";
import { PrivateRoute } from "./components/private-route/PrivateRoute";
import DemandPlanner from "./screen/demand-planner/DemandPlanner";
import GtForm from './prat_screen/gt/gtFormMain'
import PromotionList from './prat_screen/promotionList'
import PromotionApproval from './prat_screen/promotionApproval'
// import ForecastAccuracyAnalyticsRepo from './screen/reports/ForcastAccuracyAnalytics/ForecastAccuracyAnalyticsRepo'
import ForcastAccuracyReport from './screen/reports/ForcastAccuracyReport-v2/ForcastAccuracyReport'
import ForcastDetails from './screen/reports/ForcastDetails.js/ForcastDetails.jsx'
import ActivityPlan from './prat_screen/activityPlan/activityPlan';
import AccrualReport from './prat_screen/accrualReport/accrualReport';
import PreAndPostOpso from './prat_screen/preAndPostOpso/preAndPostOpso';
import ActivityNetwork from './prat_screen/activityNetwork/activityNetwork';
import SchemeReport from './prat_screen/schemeReport/schemeReport';
import PratDashboard from './prat_screen/prat-dashboard/PratDashboard';
import VerifyEmail from './screen/verify-email'
import ChangePassword from './screen/change-password'
import BaselineTotalDemand from './screen/reports/baseline-total-demand/BaselineTotalDemand';
import ConsumerPromotionList from './screen/consumer-promotion/consumer-promotion-list/ConsumerPromotionList';
import ConsumerPromotionForm from './screen/consumer-promotion/consumer-promotion-form/ConsumerPromotionForm';
import InnovationList from './screen/innovation/innovation-list/InnovationList';
import TargetTracker from './prat_screen/targetTracker/targetTracker';
import {
  ToastsContainer,
  ToastsStore,
  ToastsContainerPosition
} from "react-toasts";
import InnovationForm from './screen/innovation/innovation-form/InnovationForm';
import PdpReport from './screen/reports/pdp-report/PdpReport';

function NonPrivateRoute({ component: Component, authed, ...rest }) {
  let user = JSON.parse(localStorage.getItem("myData"))
  if (user) {
    if (user.user.prat_allowed === true) {
      return (
        <Route
          {...rest}
          render={props =>
            authed === false ? (
              <Component {...props} />
            ) : (
                // <Redirect to={{ pathname: "/primarydashboard" }} /> // this is temporary for primary dashboard only
                <Redirect to={{ pathname: "/pratdashboard" }} />
              )
          }
        />
      );
    } else {
      return (
        <Route
          {...rest}
          render={props =>
            authed === false ? (
              <Component {...props} />
            ) : (
                <Redirect to={{ pathname: "/primarydashboard" }} />
              )
          }
        />
      );
    }
  } else {
    return (
      <Route
        {...rest}
        render={props =>
          authed === false ? (
            <Component {...props} />
          ) : (
              <Redirect to={{ pathname: "/primarydashboard" }} />
            )
        }
      />
    );
  }
}


export class Routes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: false
    };
  }

  wrappedRoutes = () => {
    let user = JSON.parse(localStorage.getItem("myData"))
    return (
      <>
        <Layout />
        <Switch>
          <PrivateRoute authed={(AuthMiddleware.is_logged_in() && (user && (user.user.sfos_allowed || user.user.is_superuser)))} exact path="/primarydashboard" component={PrimaryDashboard} />
          <PrivateRoute authed={(AuthMiddleware.is_logged_in() && (user && (user.user.sfos_allowed || user.user.is_superuser)))}
            exact path="/demandplanner" component={DemandPlanner} />
          <PrivateRoute authed={(AuthMiddleware.is_logged_in() && (user && (user.user.prat_allowed || user.user.is_superuser)))}
            path='/promotionlist' component={PromotionList} />
          <PrivateRoute authed={(AuthMiddleware.is_logged_in() && (user && (user.user.prat_allowed || user.user.is_superuser)))}
            path='/pratdashboard' component={PratDashboard} />
          <PrivateRoute
            authed={(AuthMiddleware.is_logged_in() && (user && (user.user.sfos_allowed || user.user.is_superuser)))}
            exact
            path="/secondarydashboard"
            component={SecondaryDashboard}
          />
          <PrivateRoute
            authed={(AuthMiddleware.is_logged_in() && (user && (user.user.sfos_allowed || user.user.is_superuser)))}
            exact
            path="/FA/FB-Report"
            component={ForcastAccuracyReport}
          />
          <PrivateRoute
            authed={(AuthMiddleware.is_logged_in() && (user && (user.user.sfos_allowed || user.user.is_superuser)))}
            exact
            path="/forcastdetail"
            component={ForcastDetails}
          />
          <PrivateRoute
            authed={(AuthMiddleware.is_logged_in() && (user && (user.user.sfos_allowed || user.user.is_superuser)))}
            exact
            path="/baselinegraph"
            component={BaselineTotalDemand}
          />
          <PrivateRoute
            authed={(AuthMiddleware.is_logged_in() && (user && (user.user.sfos_allowed || user.user.is_superuser)))}
            exact
            path="/consumerpromotionlist"
            component={ConsumerPromotionList}
          />
          <PrivateRoute
            authed={(AuthMiddleware.is_logged_in() && (user && (user.user.sfos_allowed || user.user.is_superuser)))}
            exact
            path="/consumerpromotionform"
            component={ConsumerPromotionForm}
          />
          <PrivateRoute
            authed={(AuthMiddleware.is_logged_in() && (user && (user.user.sfos_allowed || user.user.is_superuser)))}
            exact
            path="/innovationlist"
            component={InnovationList}
          />
          <PrivateRoute
            authed={(AuthMiddleware.is_logged_in() && (user && (user.user.sfos_allowed || user.user.is_superuser)))}
            exact
            path="/innovationform"
            component={InnovationForm}
          />
          <PrivateRoute
            authed={(AuthMiddleware.is_logged_in() && (user && (user.user.sfos_allowed || user.user.is_superuser)))}
            exact
            path="/pdpreport"
            component={PdpReport}
          />
          {/* <Route exact path="/demandplanner" component={DemandPlanner} />
          <Route exact path="/forcastaccuracy" component={ForecastAccuracyAnalyticsRepo} />
          <Route exact path="/forcastdetail" component={ForcastDetails} /> */}

          <PrivateRoute authed={(AuthMiddleware.is_logged_in() && (user && (user.user.prat_allowed || user.user.is_superuser)))}
            path='/gtform' component={GtForm} />


          <PrivateRoute authed={(AuthMiddleware.is_logged_in() && (user && (user.user.prat_allowed || user.user.is_superuser)))}
            path='/promotionapproval' component={PromotionApproval} />
          <PrivateRoute authed={(AuthMiddleware.is_logged_in() && (user && (user.user.prat_allowed || user.user.is_superuser)))}
            path='/activityplan' component={ActivityPlan} />
          <PrivateRoute authed={(AuthMiddleware.is_logged_in() && (user && (user.user.prat_allowed || user.user.is_superuser)))}
            path='/accrualreport' component={AccrualReport} />
          <PrivateRoute authed={(AuthMiddleware.is_logged_in() && (user && (user.user.prat_allowed || user.user.is_superuser)))}
            path='/preandpostopso' component={PreAndPostOpso} />
          <PrivateRoute authed={(AuthMiddleware.is_logged_in() && (user && (user.user.prat_allowed || user.user.is_superuser)))}
            path='/activitynetwork' component={ActivityNetwork} />
          <PrivateRoute authed={(AuthMiddleware.is_logged_in() && (user && (user.user.prat_allowed || user.user.is_superuser)))}
            path='/schemereport' component={SchemeReport} />
            <PrivateRoute authed={(AuthMiddleware.is_logged_in() && (user && (user.user.prat_allowed || user.user.is_superuser)))}
              path='/targettracker' component={TargetTracker} />
          {/* //this route is temperarly define here for teting purpose */}
          {/* <PrivateRoute authed={(AuthMiddleware.is_logged_in() && (user && (user.user.prat_allowed || user.user.is_superuser)))}
            path='/VerifyEmail' component={VerifyEmail} /> */}
          {/* <PrivateRoute authed={(AuthMiddleware.is_logged_in() && (user && (user.user.prat_allowed || user.user.is_superuser)))}
            path='/changepassword' component={ChangePassword} /> */}
        </Switch>
      </>
    )
  };

  // componentDidMount() {
  //   setTimeout(
  //     () =>
  //       AuthMiddleware.on_change_state(user => {
  //         if (user && window.location.pathname !== "/primarydashboard") {
  //           this.setState({
  //             redirect: "/primarydashboard"
  //           });
  //         } else if (!user && window.location.pathname !== "/login")
  //           this.setState({
  //             redirect: "/login"
  //           });
  //       }),
  //     200
  //   );
  // }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      isLoggedIn: nextProps.isLoggedIn
    };
  }

  render() {
    return (
      <div>
        <BrowserRouter>
          <ToastsContainer
            position={ToastsContainerPosition.TOP_CENTER}
            store={ToastsStore}
          />
          <Switch>
            <NonPrivateRoute
              authed={AuthMiddleware.is_logged_in()}
              exact
              path="/login"
              component={LoginScreen}
            />
            <NonPrivateRoute
              authed={AuthMiddleware.is_logged_in()}
              exact
              path="/verification"
              component={VerifyEmail}
            />
            <NonPrivateRoute
              authed={AuthMiddleware.is_logged_in()}
              exact
              path="/changepassword"
              component={ChangePassword}
            />
            <NonPrivateRoute
              authed={AuthMiddleware.is_logged_in()}
              exact
              path="/"
              component={LoginScreen}
            />
            <PrivateRoute
              authed={AuthMiddleware.is_logged_in()}
              path="/"
              component={this.wrappedRoutes}
            />
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { isLoggedIn } = state.AuthReducer;
  return {
    isLoggedIn
  };
};

export default connect(mapStateToProps, null)(Routes);
